Namespace 'Monitoring.Reports.Competition'

class Monitoring.Reports.Competition.SocialAccountView extends Backbone.View
  template: JST['backbone/templates/monitoring/reports/competition/social_account']

  picture_host: 'graph.facebook.com'

  initialize:(@options={}) ->
    @channel = @options.channel

  render: ->
    @$el.html(@template({ channel: @channel, self: @ }))

  _getChannelPicture: ->
    "https://#{@picture_host}/#{@channel.fb_id}/picture?width=70&height=70"

